import React, { PureComponent } from 'react';
import { I18n } from 'react-redux-i18n';
import PropTypes from 'prop-types';

class SkypeShareButton extends PureComponent {
  onClickShare = () => {
    const { url } = this.props;
    if (!url) {
      return;
    }
    window.open(
      `https://web.skype.com/share?url=${encodeURIComponent(url)}`,
      I18n.t('common.shareOnSkype'),
      'height=700,width=500',
    );
    // share
  };

  render() {
    const { children, url } = this.props;

    return (
      <div
        onClick={this.onClickShare}
        className="skype-share d-inline-block"
        data-href={url}
        data-lang=""
        data-text=""
        data-style=""
      >
        {children}
      </div>
    );
  }
}

SkypeShareButton.propTypes = {
  children: PropTypes.node.isRequired,
  url: PropTypes.string.isRequired,
};

export default SkypeShareButton;
